<template>
  <div>
    <div v-if="currentCreative.media_type == 'image'">
      <div>
        <div>
          <!-- 非进阶创意的编辑模式或主页广告：单图展示 -->
          <div
            class="adCon-vertical"
            v-if="isFbPageAd || (edit && !advancedCreative)"
          >
            <div
              class="imgCon"
              v-if="!currentCreative.image"
            >
              <el-button
                size="small"
                @click="selectImg"
                >从创意云选择</el-button
              >
              <gm-upload-material
                ref="uploadMaterial"
                v-model:fileList="fileList"
                :saveAdFileParams="saveAdFileParam"
                :on-success="onSuccess"
                :before-upload="beforeUpload"
              >
                <el-button
                  size="small"
                  type="primary"
                  >点击上传</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                >
                  <img-tips></img-tips>
                </div>
              </gm-upload-material>
            </div>
            <div
              class="imgCon"
              v-else
            >
              <div class="tools">
                <i class="el-icon-zoom-in"></i>
                <i
                  class="el-icon-delete"
                  @click="deleImg"
                ></i>
                <gm-upload-material
                  ref="uploadMaterial"
                  v-model:fileList="fileList"
                  :saveAdFileParams="saveAdFileParam"
                  :on-success="onSuccess"
                  :before-upload="beforeUpload"
                >
                  <i class="el-icon-upload2"></i>
                </gm-upload-material>
              </div>
              <el-image
                :src="currentCreative.image"
                :preview-src-list="[currentCreative.image]"
                fit="contain"
                @error.once="setImg"
              ></el-image>
            </div>
            <!-- 文案部分放到素材下面 -->
            <div
              class="imgForm imgForm-below"
              v-if="!isFbPageAd"
            >
              <advanced-copywriter
                v-if="advancedCreative"
                :creative="currentCreative"
                :accountId="accountId"
                :pageId="pageId"
                :instagramActorId="instagramActorId"
                @setCreativeMsg="setCreativeMsg"
              ></advanced-copywriter>
              <copywriter
                v-else
                :creative="currentCreative"
                :accountId="accountId"
                :pageId="pageId"
                :instagramActorId="instagramActorId"
                :mediaType="currentCreative.media_type"
                :webUrl="currentCreative.web_url"
                :actionType="currentCreative.action_type"
                @setCreativeMsg="setCreativeMsg"
              ></copywriter>
            </div>
          </div>
          <!-- 创建模式或进阶创意编辑模式：多素材展示 -->
          <div
            class="imgMsg"
            v-else
          >
            <div
              class="imgCon"
              v-if="imgList.length < canUploadNum"
            >
              <el-button
                size="small"
                @click="selectImg(30)"
                >从创意云选择</el-button
              >
              <gm-upload-material
                ref="uploadMaterial"
                v-model:fileList="fileList"
                :saveAdFileParams="saveAdFileParam"
                :on-success="onSuccess"
                :before-upload="beforeUpload"
              >
                <el-button
                  size="small"
                  type="primary"
                  >点击上传</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                >
                  <img-tips></img-tips>
                </div>
              </gm-upload-material>
            </div>
            <div class="imgList">
              <div
                :class="['imgCon', index == activeIndex ? 'active' : '']"
                v-for="(img, index) in imgList"
                :key="img.id"
                @click="changeImg(index)"
              >
                <i
                  class="el-icon-circle-close delete"
                  @click.stop="deleImg(index)"
                ></i>
                <el-image
                  :src="img.url"
                  fit="contain"
                ></el-image>
              </div>
            </div>
          </div>
        </div>
        <!-- 多素材模式下的文案编辑区域 -->
        <div
          class="imgForm"
          v-if="!(isFbPageAd || (edit && !advancedCreative))"
        >
          <template v-if="imgList.length || advancedCreative">
            <advanced-copywriter
              v-if="advancedCreative"
              :creative="currentCreative"
              :accountId="accountId"
              :pageId="pageId"
              :instagramActorId="instagramActorId"
              @setCreativeMsg="setAdvancedCreativeMsg"
            ></advanced-copywriter>
            <copywriter
              v-else
              :creative="currentImgMsg"
              :accountId="accountId"
              :pageId="pageId"
              :instagramActorId="instagramActorId"
              :mediaType="currentCreative.media_type"
              :webUrl="currentCreative.web_url"
              :actionType="currentCreative.action_type"
              @setCreativeMsg="setImgMsg"
            ></copywriter>
          </template>
          <span
            v-else
            style="color: #f00; font-size: 12px"
            >请先上传素材再填写文案哦~~</span
          >
        </div>
      </div>
    </div>
    <img-list
      :adSeriesInfo="adSeriesInfo"
      :imgListShow="imgListShow"
      :saveAdFileParam="saveAdFileParam"
      :adMaterialParams="adMaterialParams"
      @close="imgListShow = false"
      @urlList="urlList"
      uploadTypes="img"
      :limit="limit"
    ></img-list>
  </div>
</template>
<script>
import tools from '../tools';
import adsMethods from '../../adsMethods';
import imgList from '@/views/adManagement/createAd/components/imgList';
import imgTips from './imgTips.vue';
import copywriter from './copywriter.vue';
import advancedCopywriter from './advancedCopywriter.vue';
export default {
  mixins: [tools, adsMethods],
  props: {
    adSeriesInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    currentCreative: {
      type: Object,
      default: () => {},
    },
    isFbPageAd: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    advancedCreative: {
      type: Boolean,
      default: false,
    },
    accountId: {
      type: [String, Number],
      default: '',
    },
    pageId: {
      type: [String, Number],
      default: '',
    },
    instagramActorId: {
      type: [String, Number],
      default: '',
    },
  },
  components: {
    imgList,
    imgTips,
    copywriter,
    advancedCopywriter,
  },
  data() {
    return {
      uploadTypes: 'img',
      imgListShow: false,
      activeIndex: 0,
      defaultCopywriter: { copywriter: { title: '', content: '' }, message: '' },
      limit: 1,
    };
  },
  computed: {
    canUploadNum() {
      // 进阶创意模式下素材限制为10个，普通模式30个
      return this.advancedCreative ? 10 : 30;
    },
    currentImgMsg() {
      const currentImg = this.imgList[this.activeIndex];
      if (!currentImg) {
        return {
          copywriter: { title: '', content: '' },
          message: '',
          fbAssetFeedSpec: {
            titles: [''],
            mDescriptions: [''],
            mBodies: [''],
            imgList: [],
            videos: [],
            mAdFormats: ['AUTOMATIC_FORMAT'],
            actionTypes: [],
            linkUrls: [''],
          },
        };
      }
      // 进阶创意模式下，返回包含fbAssetFeedSpec的对象
      if (this.advancedCreative) {
        return {
          ...currentImg,
          fbAssetFeedSpec: this.currentCreative.fbAssetFeedSpec,
        };
      }
      // 直接返回当前图片对象，确保包含所有属性
      return currentImg;
    },
    imgList: {
      get() {
        // 进阶创意模式下，从fbAssetFeedSpec.imgList获取
        if (this.advancedCreative) {
          return this.currentCreative.fbAssetFeedSpec?.imgList || [];
        }
        return this.currentCreative.imgList || [];
      },
      set(v) {
        if (this.advancedCreative) {
          // 进阶创意模式下，更新fbAssetFeedSpec.imgList
          const fbAssetFeedSpec = {
            ...this.currentCreative.fbAssetFeedSpec,
            imgList: v,
          };
          this.$emit('setCreativeMsg', { fbAssetFeedSpec });
        } else {
          this.setCreativeMsg(v);
        }
      },
    },
  },
  methods: {
    // 点击素材库上传
    selectImg(v) {
      this.limit = v || 1;
      // 非进阶创意的编辑模式或主页广告：单图
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.limit = 1;
      }
      // 进阶创意模式下支持多选，最多选择剩余可用数量
      if (this.advancedCreative) {
        const remainingSlots = this.canUploadNum - this.imgList.length;
        this.limit = Math.max(1, remainingSlots);
      }
      this.imgListShow = true;
    },
    // 修改创意
    setCreativeMsg(v) {
      if (this.isFbPageAd || this.edit) {
        this.$emit('setCreativeMsg', v);
      } else {
        this.$emit('setCreativeMsg', { imgList: v });
      }
    },
    // 进阶创意模式下修改文案
    setAdvancedCreativeMsg(v) {
      this.$emit('setCreativeMsg', v);
    },
    // 修改文案
    setImgMsg(v, key) {
      console.log(v, 'this.imgList, this.activeIndex, {...this.imgList[this.activeIndex]');
      const newImgList = [...this.imgList];
      newImgList[this.activeIndex] = { ...newImgList[this.activeIndex], ...v };
      this.setCreativeMsg(newImgList);
    },
    // 获取素材库图片
    urlList(v) {
      // 非进阶创意的编辑模式或主页广告：单图
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.setCreativeMsg({
          image: v[v.length - 1].url,
          source_id: v[v.length - 1].id,
          mediaSourceType: v[v.length - 1].sourceType,
          mediaOptLogId: v[v.length - 1].mediaOptLogId,
        });
      } else if (this.advancedCreative) {
        // 进阶创意模式下，转换为fbAssetFeedSpec.imgList的格式
        const newImgs = v.map((img) => ({
          source_id: img.id,
          url: img.url,
          mediaSourceType: img.sourceType,
          mediaOptLogId: img.mediaOptLogId,
        }));
        // 进阶创意模式下素材限制为10个
        this.imgList = this.imgList.concat(newImgs).slice(0, 10);
      } else {
        this.imgList = this.imgList.concat(v).slice(0, 30);
        // 从素材库选择完成后自动选中最后一张图片并初始化文案
        this.$nextTick(() => {
          const newIndex = this.imgList.length - 1;
          if (newIndex >= 0) {
            this.changeImg(newIndex);
          }
        });
      }
    },
    // 设置文案
    setCopyWriter(index) {
      let data = this.imgList[index];
      // 同步 title 数组（与 message 处理方式一致，传递完整数组）
      if (!data.title || (Array.isArray(data.title) && !data.title.some((t) => t && t.trim()))) {
        const defaultTitleArr = this.defaultTitle(this.imgList);
        data.title = [...defaultTitleArr];
      }
      // 同步 content 数组（与 message 处理方式一致，传递完整数组）
      if (!data.content || (Array.isArray(data.content) && !data.content.some((c) => c && c.trim()))) {
        const defaultContentArr = this.defaultContent(this.imgList);
        data.content = [...defaultContentArr];
      }
      // 兼容旧逻辑：确保 copywriter 对象存在
      if (!data.copywriter) {
        this.$set(data, 'copywriter', { title: '', content: '' });
      }
      if (!data.message) data.message = this.defaultMessage(this.imgList);
    },
    // 点击选择图片切换广告语
    changeImg(index) {
      this.setCopyWriter(index);
      this.activeIndex = index;
      this.$emit('setPreviewIndex', this.activeIndex);
    },
    // 点击删除图片
    deleImg(index) {
      // 非进阶创意的编辑模式或主页广告：单图删除
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.$emit('setCreativeMsg', { ...this.currentCreative, image: '' });
      } else {
        const newImgList = [...this.imgList];
        newImgList.splice(index, 1);
        this.imgList = newImgList;
        if (this.activeIndex >= newImgList.length) {
          this.activeIndex = Math.max(0, newImgList.length - 1);
        }
        this.$emit('setPreviewIndex', this.activeIndex);
      }
    },
    // 上传图片
    // upload_img(file) {
    //   this.uploadImg(file).then((data) => {
    //     if (this.edit || this.isFbPageAd) {
    //       this.$emit('setCreativeMsg', { ...this.currentCreative, source_id: data.id, image: data.url });
    //     } else {
    //       this.imgList = this.imgList.concat(data).slice(0, 30);
    //     }
    //   });
    // },
    onSuccess(data) {
      // 非进阶创意的编辑模式或主页广告：单图上传
      if ((this.edit && !this.advancedCreative) || this.isFbPageAd) {
        this.$emit('setCreativeMsg', {
          ...this.currentCreative,
          source_id: data.id,
          image: data.url,
          mediaSourceType: data.sourceType,
          mediaOptLogId: data.mediaOptLogId,
        });
      } else if (this.advancedCreative) {
        // 进阶创意模式下，转换为fbAssetFeedSpec.imgList的格式
        const newImg = {
          source_id: data.id,
          url: data.url,
          mediaSourceType: data.sourceType,
          mediaOptLogId: data.mediaOptLogId,
        };
        // 进阶创意模式下素材限制为10个
        this.imgList = this.imgList.concat(newImg).slice(0, 10);
      } else {
        this.imgList = this.imgList.concat(data).slice(0, 30);
        // 上传完成后自动选中新上传的图片并初始化文案
        this.$nextTick(() => {
          const newIndex = this.imgList.length - 1;
          if (newIndex >= 0) {
            this.changeImg(newIndex);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.imgCon {
  width: 220px;
  height: 220px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;

  // 工具栏默认隐藏，悬停时显示
  .tools {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent);
    padding: 8px 12px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    opacity: 0;
    transition: opacity 0.2s ease;

    i {
      color: #fff;
      cursor: pointer;
      font-size: 16px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      transition: transform 0.2s ease;
      &:hover {
        color: #409eff;
        transform: scale(1.2);
      }
    }

    // 上传组件内联显示
    ::v-deep .gm-upload-material,
    ::v-deep .el-upload {
      display: inline-flex;
      align-items: center;
      line-height: 1;
    }
  }

  &:hover .tools {
    opacity: 1;
  }

  .el-image {
    width: 100%;
    height: 100%;
  }

  .delete {
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 2;
    font-size: 18px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
  }
}

.imgMsg {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  margin-bottom: 15px;

  > .imgCon {
    flex-shrink: 0;
    margin-right: 10px;
  }

  .imgList {
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    max-height: 240px;

    .imgCon {
      flex-shrink: 0;
      margin-right: 10px;
      border: 3px solid transparent;
      &.active {
        border-color: #409eff;
      }
    }
  }
}

.imgForm {
  clear: both;
  padding-top: 15px;
  border-top: 1px solid #eee;

  .el-form-item {
    margin-bottom: 10px;
  }
}

// 垂直布局：素材在上，文案在下
.adCon-vertical {
  display: flex;
  flex-direction: column;

  > .imgCon {
    width: 220px;
    height: 220px;
    margin-bottom: 15px;
    flex-shrink: 0;
  }

  .imgForm-below {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
    padding-top: 15px;
    border-top: 1px solid #eee;
  }
}
</style>
